import { clienteExcluidoService } from "@/_services";

export const clienteExcluido = {
  namespaced: true,
  state: {
    list: {
      data: [],
      status: {},
    },
    insert: {
      data: [],
      status: {},
    },
    delete: {
      data: [],
      status: {},
    },
  },
  mutations: {
    deleteRequest(state) {
      state.delete.status = {
        loading: true,
      };
    },
    deleteSuccess(state, direccion) {
      state.delete.data = direccion;
      state.delete.status = {
        loaded: true,
      };
    },
    deleteError(state, error) {
      state.delete.data = [];
      state.delete.status = {
        error,
      };
    },
    insertRequest(state) {
      state.insert.status = {
        loading: true,
      };
    },
    insertSuccess(state, direccion) {
      state.insert.data = direccion;
      state.insert.status = {
        loaded: true,
      };
    },
    insertError(state, error) {
      state.insert.data = [];
      state.insert.status = {
        error,
      };
    },
    getAllRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getAllError(state, error) {
      state.list.data = [];
      state.list.status = {
        error,
      };
    },
    getAllSuccess(state, tarifas) {
      state.list.data = tarifas;
      state.list.status = {
        loaded: true,
      };
    },
  },
  actions: {
    delete({ commit }, requests) {
      commit("deleteRequest");
      clienteExcluidoService
        .eliminarClienteExcluido(requests)
        .then((suplemento) => {
          commit("deleteSuccess", suplemento);
        })
        .catch((error) => {
          commit("deleteError", error);
        });
    },
    getAll({ commit }, req) {
      commit("getAllRequest");
      clienteExcluidoService
        .getAllClientesExcluidos(req.pagination, req.filters)
        .then((tarifas) => {
          commit("getAllSuccess", tarifas);
        })
        .catch((error) => {
          commit("getAllError", error);
        });
    },
    nuevo({ commit }, req) {
      commit("insertRequest");
      clienteExcluidoService
        .nuevoClienteExcluido(req)
        .then((res) => {
          commit("insertSuccess", res);
        })
        .catch((error) => {
          commit("insertError", error);
        });
    },
  },
};
